/**
 * /tenants/$slug/authentication/locations/$id/edit — route shim.
 */

import { createFileRoute } from "@tanstack/react-router";
import { fetchNamedLocations } from "@/features/named-locations/queries";
import { queryKeys } from "@/lib/query-keys";
import { EditNamedLocationPage } from "@/features/named-locations/pages/edit-named-location-page";

export const Route = createFileRoute(
  "/_authed/tenants/$slug/authentication/locations/$id/edit",
)({
  loader: ({ context }) =>
    context.queryClient.ensureQueryData({
      queryKey: queryKeys.namedLocations.list(context.tenant.id),
      queryFn: () => fetchNamedLocations(context.tenant.id),
    }),
  component: EditNamedLocationPage,
});
